












































































































import { createComponent } from "../ts/EditForm";
export default createComponent();
